module.exports = __webpack_public_path__ + "img/bottom.fed3cbed.png";